<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Daftar Sesi Live Class Quiz' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            Daftar Sesi Live Class Quiz
        </h3>

        <v-card>
            <v-card-title>
                Daftar Sesi Live Class Quiz
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createLiveQuizSession()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Sesi
                </v-btn>
            </v-card-title>

            <v-divider />
            <app-datatable
                :items="transaksiList"
                :headers="headers"
                :hasAction="false"
                :has-custom-search="true"
                :has-custom-pagination="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                :loading="isLoading"
                v-on:dblClicked="updateProduk()"
                v-on:deleted="deleteProduk($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doFilter();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Moment from "moment";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global//components/plugins/Spinner";

export default {
    name: "Addlivequiz",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            transaksiList: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            search: null,
            pagination: {
                search: "",
                perPage: 12,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            params: {
                search: "",
                order_id: null,
                email: null,
                sort: null,
                student_name: null,
                phone_number: null,
                package_name: null,
                group_name: null,
                package: null,
                group: null,
                page: 1,
                per_page: 12,
                totalPages: 0,
                total_transaction: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Nama Sesi", value: "session_name", width: 200 },
                { text: "Mata Pelajaran", value: "mapel", width: 250 },
                { text: "Teacher", value: "teacher", width: 200 },
                { text: "Created At", value: "created_at", width: 200 },
                { text: "Schedule", value: "schedule", width: 200 },
            ],
            headersKey: [
                "session_name",
                "mapel",
                "teacher",
                "created_at",
                "schedule",
            ],
            showModal: true,
        };
    },

    mounted: function () {
        // this.fetchData();
    },

    watch: {
        "pagination.currentPage": function (val) {
            this.params.page = val;
            this.fetchData();
        },
        params: function () {
            this.fetchData();
        },
    },

    computed: {},

    methods: {
        fetchData: function () {
            var context = this;
            this.isLoading = true;

            SalesService.getListTransaksi(context.params, function (result) {
                context.transaksiList = [];
                context.pagination.totalPages = parseInt(
                    result.data.total_transaction / context.pagination.perPage,
                );
                context.maxPage = parseInt(
                    result.data.total_transaction / context.pagination.perPage,
                );
                context.params.total_transaction =
                    result.data.total_transaction;

                if (result.success) {
                    result.data.list_transactions.forEach(
                        function (content, index) {
                            var row = {
                                no: index,
                                id: content.order_id,
                                order_id: content.order_id,
                                email: content.email,
                                nama_siswa: content.nama_siswa,
                                handphone: content.handphone,
                                package_name: content.paket,
                                group_name: content.group,
                                nominal: content.nominal,
                                status: content.status,
                                school: content.school,
                                payment_account: content.payment_account,
                                payment_company: content.payment_company,
                                payment_method: content.payment_method,
                                transaction_payment_time:
                                    content.transaction_payment_time,
                                transaction_expired_time:
                                    content.transaction_expired_time,
                            };

                            context.transaksiList.push(row);
                        },
                    );
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },

        doFilter() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            this.fetchData();
        },

        clearFilter() {
            this.params = {
                search: "",
                order_id: null,
                email: null,
                sort: null,
                student_name: null,
                phone_number: null,
                package: null,
                group: null,
                page: 1,
                per_page: 12,
                totalPages: 0,
                total_transaction: 0,
                sortMode: "desc",
            };
        },

        createLiveQuizSession: function () {
            this.$router.push({ path: "/addlivequiz/form" });
        },

        updateProduk: function () {
            var context = this;
            var produkId = this.selectedRow.id;
            SalesService.getDetailTransaksi(produkId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.selectedRow = {
                        id: result.data.order_id,
                        email: result.data.email,
                        nama_siswa: result.data.nama_siswa,
                        handphone: result.data.handphone,
                        paket: result.data.paket,
                        group: result.data.group,
                        nominal: result.data.nominal,
                        status: result.data.status,
                        school: result.data.school,
                        payment_account: result.data.payment_account,
                        payment_company: result.data.payment_company,
                        payment_method: result.data.payment_method,
                        transaction_payment_time:
                            result.data.transaction_payment_time,
                        transaction_expired_time:
                            result.data.transaction_expired_time,
                    };

                    if (context.selectedRow.transaction_payment_time) {
                        context.selectedRow.transaction_payment_time = Moment(
                            context.selectedRow.transaction_payment_time,
                        ).format("DD MMMM, YYYY h:mm");
                        context.selectedRow.transaction_expired_time = Moment(
                            context.selectedRow.transaction_expired_time,
                        ).format("DD MMMM, YYYY h:mm");
                    }

                    context.showModal = true;
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// AddLiveQuiz.vue?3703662c